import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserStateStepper } from "@/pages/auth/post_login/useUserStateStepper";
import UserStateStepper from "./UserStateStepper";

const PostLogin = () => {
  const navigate = useNavigate();
  const {
    isStepperOpen,
    userStateInfo,
    isLoading,
    checkUserState,
    handleStepperComplete,
    updateUserState,
  } = useUserStateStepper();

  useEffect(() => {
    // Check for hash fragment in URL for post-login redirect
    const hash = window.location.hash;
    if (hash && hash.startsWith("#")) {
      const selectedPage = hash.substring(1); // Remove the # symbol
      if (selectedPage) {
        // Redirect to the selected page
        navigate(`/${selectedPage}`);
        return;
      }
    }

    // Check user state immediately when component mounts
    checkUserState();
  }, [navigate, checkUserState]); // Add checkUserState to dependency array

  // Show loading state while checking user state
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#65C466] mx-auto mb-4"></div>
          <p className="text-gray-600">Setting up your account...</p>
        </div>
      </div>
    );
  }

  // If all states are false (user is complete), redirect to dashboard/contact
  console.log("user state info:", userStateInfo);
  if (
    userStateInfo &&
    !userStateInfo.identity_data_completion_needed &&
    !userStateInfo.package_selection_needed &&
    userStateInfo.has_reserved === null &&
    userStateInfo.has_payment_card === null
  ) {
    // Redirect to dashboard/contact
    window.location.href = "/settings/myprofile";
    return null;
  }

  // If no stepper is needed and we have user state info, don't render anything
  // The navigation will happen in the useUserStateStepper hook
  if (userStateInfo && !isStepperOpen) {
    return null;
  }

  return (
    <>
      {userStateInfo && isStepperOpen && (
        <UserStateStepper
          isOpen={isStepperOpen}
          onComplete={handleStepperComplete}
          userStateInfo={userStateInfo}
          onUserStateUpdate={updateUserState}
        />
      )}
    </>
  );
};

export default PostLogin;
